import './style.scss';
import Spinner from './spinner.js';

export default Spinner;